import { useThree } from '@react-three/fiber';
import { Html } from '@react-three/drei';
import { ThemeProvider } from 'styled-components';
import { theme } from '../../theme';

const FigureOverlay = ({ hidden, children, customStyle={} }) => {
  const { gl } = useThree();
  return (
    <Html
      portal={{current: gl.domElement.parentNode}}
      style={{
        pointerEvents: 'none',
        transition: 'all 0.5s',
        opacity: hidden ? 0 : 1,
        transform: `scale(${hidden ? 0.0 : 1})`,
        ...customStyle
      }}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </Html>
  );
};

export default FigureOverlay;
